import React, { useEffect, useState } from "react";
import SelectInviteUsers from "./select-invite-users";
import { Alert, Checkbox, FormControl, ListItemText, MenuItem, Select, SelectChangeEvent, Snackbar, SnackbarCloseReason } from "@mui/material";
import ChangePassword from "./change-password";
import { User } from "../../Models/User";
import { DropUser, getusers, InviteUser, UpdateUser } from "../../Services/Users";
import { useAppDispatch } from "../store/store";
import { fetchHeaderData } from "../store/headerSlice";
import { UserInvite } from "../../Models/UserInvite";
import { useTranslation } from "react-i18next";
import Agents from "./agents";

const Users: React.FunctionComponent<{}> = (props) => {

    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState<any>();
    const [idUser, setIdUser] = useState<any>();
    const [change, setChange] = useState(false);
    const [userValue, setUserValue] = useState<UserInvite>()
    const dispatch = useAppDispatch();
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [colorSnackbar, setColorSnackbar] = useState<any>("");
    const [message, setMessage] = useState<string>();
    const [selectedRoles, setSelectedRoles] = useState({
        inviteUser: true,
        agents: true,
        users: false,
        changePassword: false
    });
    const { t } = useTranslation();

    useEffect(() => {
        getusers().then((data) => {
            setLoading(false)
            setUsers(data)
        }).catch(err => {
            console.log("Error");
        });
    }, [change])

    const handleCloseSnackbar = (
        event?: React.SyntheticEvent | Event,
        reason?: SnackbarCloseReason,
    ) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    }

    const ChangeMessageHndler = (msg: string, color: string) => {
        setOpenSnackbar(true)
        setColorSnackbar(color)
        setMessage(msg)
    }

    const InviteUserHandler = (user: any) => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isValidEmail = emailPattern.test(user.email as string);
        if (isValidEmail) {
            InviteUser(user).then((data) => {
                dispatch(fetchHeaderData());
                setChange(!change)
                ChangeMessageHndler("User Invited Successfully!", "success")
            }).catch(err => {
                ChangeMessageHndler(err.response.data.error, "error")
            });
        } else {
            ChangeMessageHndler("Invalid email address. Please enter a valid email address.", "error")
        }
    }

    const changeMessageHandler = (color: string, msg: string) => {
        setColorSnackbar(color)
        setOpenSnackbar(true)
        setMessage(msg)
    }

    const HandleUpdateUser = () => {
        UpdateUser(userValue).then((data) => {
            ChangeMessageHndler("User Updated Successfully!", "success")
            setChange(!change)
        }).catch((err) => {
            ChangeMessageHndler(err.response.data.error, "error")
        })
    }

    const handleChange = (event: any) => {
        const { name, value } = event.target;
        setUserValue((prev) => ({ ...prev, [name]: value }));
    }

    const dropUser = () => {
        DropUser(idUser).then((data) => {
            ChangeMessageHndler("User Deleted Successfully!", "success")
            setChange(!change)
        }).catch(() => {
            ChangeMessageHndler("Failed to delete user", "error")
        })
    }

    return loading ? (<div className="container-xxl flex-grow-1 container-p-y"> Loading ...</div>) : (
        <div className="container-xxl flex-grow-1 container-p-y ">

            <div className="cp-card card users-mobile mb-4" style={{ overflowX: "auto" }}>
                <div className="cp-tabs">
                    <button className={`cp-tab ${selectedRoles.inviteUser ? "cp-tab-active" : ""}`} onClick={() => setSelectedRoles({ ...selectedRoles, inviteUser: true, changePassword: false })}>
                        {t("users.inviteUsers")}
                    </button>
                    <button className={`cp-tab ${selectedRoles.changePassword ? "cp-tab-active" : ""}`} onClick={() => setSelectedRoles({ ...selectedRoles, inviteUser: false, changePassword: true })}>
                        {t("users.changePassword")}
                    </button>
                </div>
                <div className="padd-20">
                    {selectedRoles.changePassword ?
                        <ChangePassword onChangeMessage={ChangeMessageHndler} />
                        : <SelectInviteUsers onInviteUser={InviteUserHandler} />}
                </div>
            </div>

            <div className="cp-card mb-4" style={{ overflowX: "auto" }}>
                <div className="cp-tabs">
                    <button className={`cp-tab ${selectedRoles.agents ? "cp-tab-active" : ""}`} onClick={() => setSelectedRoles({ ...selectedRoles, agents: true, users: false })}>
                       {t("home.agents")}
                    </button>
                    <button className={`cp-tab ${selectedRoles.users ? "cp-tab-active" : ""}`} onClick={() => setSelectedRoles({ ...selectedRoles, agents: false, users: true })}>
                        {t("sidebar.users")}
                    </button>
                </div>
                <div className="padd-20">
                    {selectedRoles.agents ? <Agents onChangeMessagehandler={changeMessageHandler} />
                        :
                        <div>
                            <div className="manager-header mb-4">
                                <h2 className="manager-title">{t("sidebar.users")}</h2>
                            </div>
                            <div className="table-responsive text-nowrap ">
                                <table className="table" >
                                    <thead className="table-thead">
                                        <tr>
                                            <th> {t("users.userName")}</th>
                                            <th> {t("propertyDetails.emailAddress")}</th>
                                            <th> {t("users.userRole")}</th>
                                            <th> {t("users.enhancePhotos")}</th>
                                            <th> {t("users.generatePhotos")}</th>
                                            <th> {t("navbar.balanceCard.listings")}</th>
                                            <th> {t("users.status")}</th>
                                            <th> {t("propertiesPage.actions")}</th>
                                        </tr>
                                    </thead>
                                    <tbody className="table-tbody">
                                        {users && users.map((user: any, index: any) => {
                                            return <tr key={"line_" + index}>
                                                <td> {user.lastename.charAt(0).toUpperCase() + user.lastename.slice(1)} {" "} {user.firstName}
                                                </td>

                                                <td>
                                                    {user.email ? user.email : ""}
                                                </td>

                                                <td>
                                                    {user.rule.charAt(0).toUpperCase() + user.rule.slice(1)}
                                                </td>

                                                <td>{user.enhancephotos ? user.enhancephotos : 0}</td>
                                                <td>{user.generatephotos ? user.generatephotos : 0}</td>
                                                <td>{user.listings ? user.listings : 0}</td>

                                                <td>
                                                    {user.statu == true && <div style={{ marginTop: "8px" }}><span className="badge border-81 bg-label-success">{t("users.active")}</span></div>}
                                                    {user.statu == false && <div style={{ marginTop: "8px" }}><span className="badge border-81 bg-label-secondary">{t("users.pending")}</span></div>}
                                                </td>

                                                <td>
                                                    <button type="button" className="btn p-0  hide-arrow" data-bs-target="#UpdateModal" data-bs-toggle="modal"
                                                        onClick={() => setUserValue(user)} >
                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g clipPath="url(#clip0_1117_3231)">
                                                                <path d="M5.83398 5.8335H5.00065C4.55862 5.8335 4.1347 6.00909 3.82214 6.32165C3.50958 6.63421 3.33398 7.05814 3.33398 7.50016V15.0002C3.33398 15.4422 3.50958 15.8661 3.82214 16.1787C4.1347 16.4912 4.55862 16.6668 5.00065 16.6668H12.5007C12.9427 16.6668 13.3666 16.4912 13.6792 16.1787C13.9917 15.8661 14.1673 15.4422 14.1673 15.0002V14.1668" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M16.9875 5.48759C17.3157 5.15938 17.5001 4.71424 17.5001 4.25009C17.5001 3.78594 17.3157 3.34079 16.9875 3.01259C16.6593 2.68438 16.2142 2.5 15.75 2.5C15.2858 2.5 14.8407 2.68438 14.5125 3.01259L7.5 10.0001V12.5001H10L16.9875 5.48759Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M13.334 4.1665L15.834 6.6665" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_1117_3231">
                                                                    <rect width="20" height="20" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                    </button>
                                                    <button type="button" className="btn p-0  hide-arrow marg-left-10" data-bs-toggle="modal"
                                                        data-bs-target="#dropModal" onClick={() => setIdUser(user._id)}>
                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g clipPath="url(#clip0_168_187)">
                                                                <path d="M3.33398 5.83334H16.6673" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M8.33398 9.16666V14.1667" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M11.666 9.16666V14.1667" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M4.16602 5.83334L4.99935 15.8333C4.99935 16.2754 5.17494 16.6993 5.4875 17.0119C5.80007 17.3244 6.22399 17.5 6.66602 17.5H13.3327C13.7747 17.5 14.1986 17.3244 14.5112 17.0119C14.8238 16.6993 14.9994 16.2754 14.9994 15.8333L15.8327 5.83334" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M7.5 5.83333V3.33333C7.5 3.11232 7.5878 2.90036 7.74408 2.74408C7.90036 2.5878 8.11232 2.5 8.33333 2.5H11.6667C11.8877 2.5 12.0996 2.5878 12.2559 2.74408C12.4122 2.90036 12.5 3.11232 12.5 3.33333V5.83333" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_168_187">
                                                                    <rect width="20" height="20" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                    </button>
                                                </td>
                                            </tr>
                                        })}
                                    </tbody>
                                </table>
                                {users && users.length == 0 && <h3 className="empty mb-4">{t("users.noUsers")}</h3>}
                            </div>
                        </div>
                    }
                </div>
            </div>



            <div className="modal fade" id="dropModal" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="title-18">{t("propertiesPage.confirmation")}</h5>
                        </div>
                        <div className="modal-body mb-3 mt-3">
                            <p className="para-16  text-start">{t("users.deleteUserQuestion")}</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="button-dash btn-outline-secondary back-trans padd-15 padd-5-15-mb marg-right-16" data-bs-dismiss="modal">
                                {t("propertiesPage.no")}
                            </button>
                            <button type="button" data-bs-dismiss="modal" className="button-dash padd-15 padd-5-15-mb btn-danger" onClick={dropUser}>
                                {t("propertiesPage.yes")}</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="UpdateModal" aria-hidden="true">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="title-24 title-20-mb" id="exampleModalLabel1">{t("users.user")}</h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">

                            <div className="row  mt-4">
                                <div className="col-md-6 text-start  mb-3">
                                    <label htmlFor="User Name" className="form-label ">{t("users.userName")}</label>
                                    <input type="text" className="form-control custom-select" name="lastename" value={userValue?.lastename || ""} onChange={handleChange} />
                                </div>
                                <div className="col-md-6 text-start  mb-3">
                                    <label htmlFor="User Email" className="form-label ">{t("users.userEmail")}</label>
                                    <input type="text" className="form-control custom-select" name="email" value={userValue?.email || ""} onChange={handleChange} />
                                </div>
                            </div>
                            <div className="row ">
                                <div className="col-md-6 text-start  mb-3">
                                    <label htmlFor="User Rule" className="form-label">{t("users.userRule")}</label>
                                    <div className="d-flex justify-content-start">
                                        <FormControl fullWidth>
                                            {userValue?.rule && <Select
                                                className="custom-select border-ced4da"
                                                displayEmpty
                                                value={userValue?.rule || ""}
                                                name="rule"
                                                inputProps={{ 'aria-label': 'Select' }}
                                                onChange={handleChange}>
                                                <MenuItem value="" disabled>
                                                    {t("propertiesPage.select")}
                                                </MenuItem>
                                                <MenuItem value="Admin" >
                                                    {t("users.admin")}
                                                </MenuItem>
                                                <MenuItem value="Agent" >
                                                    {t("users.agent")}
                                                </MenuItem>
                                                <MenuItem value="Moderator" >
                                                    {t("users.moderator")}
                                                </MenuItem>
                                            </Select>}
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="col-md-6 text-start  mb-3">
                                    <label htmlFor="Enhance Photos" className="form-label">{t("users.enhancePhotosLabel")}</label>
                                    <input type="number" min={0} className="form-control custom-select" placeholder="0" name="enhancephotos" value={userValue?.enhancephotos} onChange={handleChange} />
                                </div>
                            </div>
                            <div className="row ">
                                <div className="col-md-6 text-start  mb-3">
                                    <label htmlFor="Generate Photos" className="form-label ">{t("users.generatePhotosLabel")}</label>
                                    <input type="number" min={0} className="form-control custom-select" placeholder="0" name="generatephotos" value={userValue?.generatephotos} onChange={handleChange} />
                                </div>
                                <div className="col-md-6 text-start mb-3">
                                    <label htmlFor="Listings" className="form-label ">{t("navbar.balanceCard.listings")}</label>
                                    <input type="number" min={0} className="form-control custom-select" placeholder="0" name="listings" value={userValue?.listings} onChange={handleChange} />
                                </div>
                            </div>

                        </div>
                        <div className="modal-footer">
                            <button type="button" data-bs-dismiss="modal" className="button-dash back-746AFF color-FFFFFF  border-746AFF padd-15-30" onClick={HandleUpdateUser}>
                                {t("propertiesPage.save")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <Snackbar open={openSnackbar} onClose={handleCloseSnackbar} autoHideDuration={5000}>
                <Alert
                    onClose={handleCloseSnackbar}
                    severity={colorSnackbar || "info"}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {message}
                </Alert>
            </Snackbar>
        </div>
    )
}

export default Users
